export default function TopProducts({ data }) {
  return (
    <div className="card shadow-sm border-0">
      <div className="card-body">
        <h5 className="fw-bold mb-3">Produk Paling Banyak Dilihat</h5>

        <table className="table">
          <thead>
            <tr>
              <th>Produk</th>
              <th>Kategori</th>
              <th>Klik</th>
            </tr>
          </thead>
          <tbody>
            {data.map(p => (
              <tr key={p.id}>
                <td>{p.nama_produk}</td>
                <td>{p.category?.name}</td>
                <td className="fw-semibold text-primary">
                  {p.click_count}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
